import Icon from '../components/Icon.vue'

Icon.register({
  'th-large': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M296 32H488C501.3 32 512 42.7 512 56V216C512 229.3 501.3 240 488 240H296C282.7 240 272 229.3 272 216V56C272 42.7 282.7 32 296 32zM216 32H24C10.7 32 0 42.7 0 56V216C0 229.3 10.7 240 24 240H216C229.3 240 240 229.3 240 216V56C240 42.7 229.3 32 216 32zM0 296V456C0 469.3 10.7 480 24 480H216C229.3 480 240 469.3 240 456V296C240 282.7 229.3 272 216 272H24C10.7 272 0 282.7 0 296zM296 480H488C501.3 480 512 469.3 512 456V296C512 282.7 501.3 272 488 272H296C282.7 272 272 282.7 272 296V456C272 469.3 282.7 480 296 480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/th-large.js
// module id = /sU4
// module chunks = 144